import React from "react";
import { Reveal } from "../shared/Reveal";

const RESULTS = [
  ["26.7%", "Tex Plastics", "£237,000 saved every year"],
  ["30%", "Bonaprene", "Industrial & aeronautical lines"],
  ["22%", "Airport, Peru", "Savings immediately after install"],
  ["87%", "Single circuit", "294.68 → 37.26 kWh measured"],
];

export default function Results() {
  return (
    <section id="results" className="results">
      <div className="wrap">
        <Reveal className="eyebrow" tag="div">PROVEN RESULTS</Reveal>
        <Reveal className="h2" tag="div">We Prove Them. <span className="g">Measured, Not Estimated.</span></Reveal>
        <Reveal className="lead" tag="p">Case studies have demonstrated energy savings of up to 30% through identifying and eliminating hidden operational waste before capital investment.</Reveal>
        <div className="rgrid">
          {RESULTS.map(([v, cl, ln], i) => (
            <Reveal className="rc" tag="div" key={cl} style={{ transitionDelay: `${i * 0.08}s` }} data-testid={`result-${i}`}>
              <div className="v">{v}</div><div className="cl">{cl}</div><div className="ln">{ln}</div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
